const EDIT_TOOL_TYPES = {
  annotation: { key: 'annotation', name: 'annotation' },
  segmentation: { key: 'segmentation', name: 'segmentation' },
};

export default EDIT_TOOL_TYPES;
